import { UITypes } from "types"

export const checkRoleType = (value?: number): UITypes.UserRole | undefined => {
  switch (value) {
    case 1:
      return "vendor-admin"
    case 2:
      return "sales-manager"
    case 3:
      return "vendor-warehouse"
    case 4:
      return "contractor-manager"
    case 8:
      return "warehouse-manager"
    case 9:
      return "contractor-admin"
    case 10:
      return "contractor-engineer"
    case 11:
      return "contractor-technician"

    default:
      return undefined
  }
}
